// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlayArrow48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow48Filled: FC<PlayArrow48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M16 37.85v-28l22 14-22 14Z" />
        </svg>
    );
};

export default PlayArrow48Filled;
